import { render, staticRenderFns } from "./riskWarningReport.vue?vue&type=template&id=9e268e4c&scoped=true&"
import script from "./riskWarningReport.vue?vue&type=script&lang=js&"
export * from "./riskWarningReport.vue?vue&type=script&lang=js&"
import style0 from "./riskWarningReport.vue?vue&type=style&index=0&id=9e268e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e268e4c",
  null
  
)

export default component.exports